import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { SendBylawsRequest } from '@bignest/bylaws-kit';

export interface SendBylawsResponse {
  requestId: string;
  status: string;
}

@Injectable({ providedIn: 'root' })
export class BackendService {
  private readonly http = inject(HttpClient);
  private readonly functionsBaseUrl = environment.functionsBaseUrl;

  sendBylaws(request: SendBylawsRequest): Observable<SendBylawsResponse> {
    const url = `${this.functionsBaseUrl}sendBylaws`;
    return this.http.post<SendBylawsResponse>(url, request);
  }
}
